import { textStyleConst } from '@klarna/designtokens';
import * as FontFamilies from '@bubble-ui/particle-font-families';
import systemFontsDefaultLetterSpacing from '@bubble-ui/particle-system-fonts-default-letter-spacing';
var fontSizesSmall = {
  huge: 40,
  primary: 35,
  secondary: 31,
  tertiary: 27,
  quaternary: 24,
  grande: 21,
  tall: 18,
  body: 16,
  default: 14,
  tiny: 12,
  micro: 10
};
var lineHeights = {
  base: 1.05,
  double: 1.15,
  high: 1.3,
  highest: 1.45
};
function textStylesFromParameters(fontFamily, fontSizes, lineHeights) {
  var useRelativeLineHeights = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : true;
  function textStyleToken(fontFam, sizeId) {
    var lineHeightId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'base';
    var letterSpacing = arguments.length > 3 ? arguments[3] : undefined;
    return textStyleConst({
      fontFamily: fontFam.fontFamily,
      fontWeight: fontFam.fontWeight,
      fontSize: fontSizes[sizeId],
      lineHeight: useRelativeLineHeights ? Math.round(lineHeights[lineHeightId] * fontSizes[sizeId]) : lineHeights[lineHeightId],
      letterSpacing: letterSpacing ? letterSpacing : systemFontsDefaultLetterSpacing(fontSizes[sizeId])
    });
  }
  return {
    'text-style/headings/titles/bold/huge': textStyleToken(fontFamily.BOLD, 'huge', 'base'),
    'text-style/headings/titles/bold/primary': textStyleToken(fontFamily.BOLD, 'primary', 'base'),
    'text-style/headings/titles/bold/secondary': textStyleToken(fontFamily.BOLD, 'secondary', 'base'),
    'text-style/headings/titles/bold/tertiary': textStyleToken(fontFamily.BOLD, 'tertiary', 'base'),
    'text-style/headings/titles/bold/quaternary': textStyleToken(fontFamily.BOLD, 'quaternary', 'base'),
    'text-style/headings/titles/bold/grande': textStyleToken(fontFamily.BOLD, 'grande', 'base'),
    'text-style/headings/titles/medium/tertiary': textStyleToken(fontFamily.MEDIUM, 'tertiary', 'base'),
    'text-style/headings/titles/medium/quaternary': textStyleToken(fontFamily.MEDIUM, 'quaternary', 'base'),
    'text-style/headings/titles/medium/grande': textStyleToken(fontFamily.MEDIUM, 'grande', 'base'),
    'text-style/headings/blocks/bold/huge': textStyleToken(fontFamily.BOLD, 'huge', 'double'),
    'text-style/headings/blocks/bold/primary': textStyleToken(fontFamily.BOLD, 'primary', 'double'),
    'text-style/headings/blocks/bold/secondary': textStyleToken(fontFamily.BOLD, 'secondary', 'double'),
    'text-style/headings/blocks/bold/tertiary': textStyleToken(fontFamily.BOLD, 'tertiary', 'double'),
    'text-style/headings/blocks/bold/quaternary': textStyleToken(fontFamily.BOLD, 'quaternary', 'double'),
    'text-style/headings/blocks/bold/grande': textStyleToken(fontFamily.BOLD, 'grande', 'double'),
    'text-style/headings/blocks/medium/tertiary': textStyleToken(fontFamily.MEDIUM, 'tertiary', 'double'),
    'text-style/headings/blocks/medium/quaternary': textStyleToken(fontFamily.MEDIUM, 'quaternary', 'double'),
    'text-style/headings/blocks/medium/grande': textStyleToken(fontFamily.MEDIUM, 'grande', 'double'),
    'text-style/text/labels/grande/bold': textStyleToken(fontFamily.BOLD, 'grande', 'base'),
    'text-style/text/labels/grande/medium': textStyleToken(fontFamily.MEDIUM, 'grande', 'base'),
    'text-style/text/labels/grande/regular': textStyleToken(fontFamily.REGULAR, 'grande', 'base'),
    'text-style/text/labels/tall/bold': textStyleToken(fontFamily.BOLD, 'tall', 'base'),
    'text-style/text/labels/tall/medium': textStyleToken(fontFamily.MEDIUM, 'tall', 'base'),
    'text-style/text/labels/tall/regular': textStyleToken(fontFamily.REGULAR, 'tall', 'base'),
    'text-style/text/labels/body/bold': textStyleToken(fontFamily.BOLD, 'body', 'base'),
    'text-style/text/labels/body/medium': textStyleToken(fontFamily.MEDIUM, 'body', 'base'),
    'text-style/text/labels/body/regular': textStyleToken(fontFamily.REGULAR, 'body', 'base'),
    'text-style/text/labels/default/bold': textStyleToken(fontFamily.BOLD, 'default', 'base'),
    'text-style/text/labels/default/medium': textStyleToken(fontFamily.MEDIUM, 'default', 'base'),
    'text-style/text/labels/default/regular': textStyleToken(fontFamily.REGULAR, 'default', 'base'),
    'text-style/text/labels/tiny/bold': textStyleToken(fontFamily.BOLD, 'tiny', 'base'),
    'text-style/text/labels/tiny/medium': textStyleToken(fontFamily.MEDIUM, 'tiny', 'base'),
    'text-style/text/labels/tiny/regular': textStyleToken(fontFamily.REGULAR, 'tiny', 'base'),
    'text-style/text/labels/micro/bold': textStyleToken(fontFamily.BOLD, 'micro', 'base'),
    'text-style/text/labels/micro/medium': textStyleToken(fontFamily.MEDIUM, 'micro', 'base'),
    'text-style/text/labels/micro/regular': textStyleToken(fontFamily.REGULAR, 'micro', 'base'),
    'text-style/text/paragraphs/grande/bold': textStyleToken(fontFamily.BOLD, 'grande', 'high'),
    'text-style/text/paragraphs/grande/medium': textStyleToken(fontFamily.MEDIUM, 'grande', 'high'),
    'text-style/text/paragraphs/grande/regular': textStyleToken(fontFamily.REGULAR, 'grande', 'high'),
    'text-style/text/paragraphs/tall/bold': textStyleToken(fontFamily.BOLD, 'tall', 'high'),
    'text-style/text/paragraphs/tall/medium': textStyleToken(fontFamily.MEDIUM, 'tall', 'high'),
    'text-style/text/paragraphs/tall/regular': textStyleToken(fontFamily.REGULAR, 'tall', 'high'),
    'text-style/text/paragraphs/body/bold': textStyleToken(fontFamily.BOLD, 'body', 'high'),
    'text-style/text/paragraphs/body/medium': textStyleToken(fontFamily.MEDIUM, 'body', 'high'),
    'text-style/text/paragraphs/body/regular': textStyleToken(fontFamily.REGULAR, 'body', 'high'),
    'text-style/text/paragraphs/default/bold': textStyleToken(fontFamily.BOLD, 'default', 'high'),
    'text-style/text/paragraphs/default/medium': textStyleToken(fontFamily.MEDIUM, 'default', 'high'),
    'text-style/text/paragraphs/default/regular': textStyleToken(fontFamily.REGULAR, 'default', 'high'),
    'text-style/text/paragraphs/tiny/bold': textStyleToken(fontFamily.BOLD, 'tiny', 'high'),
    'text-style/text/paragraphs/tiny/medium': textStyleToken(fontFamily.MEDIUM, 'tiny', 'high'),
    'text-style/text/paragraphs/tiny/regular': textStyleToken(fontFamily.REGULAR, 'tiny', 'high'),
    'text-style/text/super-paragraphs/grande/bold': textStyleToken(fontFamily.BOLD, 'grande', 'highest'),
    'text-style/text/super-paragraphs/grande/medium': textStyleToken(fontFamily.MEDIUM, 'grande', 'highest'),
    'text-style/text/super-paragraphs/grande/regular': textStyleToken(fontFamily.REGULAR, 'grande', 'highest'),
    'text-style/text/super-paragraphs/tall/bold': textStyleToken(fontFamily.BOLD, 'tall', 'highest'),
    'text-style/text/super-paragraphs/tall/medium': textStyleToken(fontFamily.MEDIUM, 'tall', 'highest'),
    'text-style/text/super-paragraphs/tall/regular': textStyleToken(fontFamily.REGULAR, 'tall', 'highest'),
    'text-style/text/super-paragraphs/body/bold': textStyleToken(fontFamily.BOLD, 'body', 'highest'),
    'text-style/text/super-paragraphs/body/medium': textStyleToken(fontFamily.MEDIUM, 'body', 'highest'),
    'text-style/text/super-paragraphs/body/regular': textStyleToken(fontFamily.REGULAR, 'body', 'highest'),
    'text-style/text/super-paragraphs/default/bold': textStyleToken(fontFamily.BOLD, 'default', 'highest'),
    'text-style/text/super-paragraphs/default/medium': textStyleToken(fontFamily.MEDIUM, 'default', 'highest'),
    'text-style/text/super-paragraphs/default/regular': textStyleToken(fontFamily.REGULAR, 'default', 'highest'),
    'text-style/text/super-paragraphs/tiny/bold': textStyleToken(fontFamily.BOLD, 'tiny', 'highest'),
    'text-style/text/super-paragraphs/tiny/medium': textStyleToken(fontFamily.MEDIUM, 'tiny', 'highest'),
    'text-style/text/super-paragraphs/tiny/regular': textStyleToken(fontFamily.REGULAR, 'tiny', 'highest')
  };
}
export function customTextStyles(_ref) {
  var {
    fontFamily = FontFamilies.TEXT_REGULAR.fontFamily,
    fontWeights = {
      regular: FontFamilies.TEXT_REGULAR.fontWeight,
      medium: FontFamilies.TEXT_MEDIUM.fontWeight,
      bold: FontFamilies.TEXT_BOLD.fontWeight
    }
  } = _ref;
  return textStylesFromParameters({
    REGULAR: {
      fontFamily,
      fontWeight: fontWeights.regular
    },
    MEDIUM: {
      fontFamily,
      fontWeight: fontWeights.medium
    },
    BOLD: {
      fontFamily,
      fontWeight: fontWeights.bold
    }
  }, fontSizesSmall, lineHeights, true);
}
var defaultTextStyles = textStylesFromParameters({
  REGULAR: FontFamilies.TEXT_REGULAR,
  MEDIUM: FontFamilies.TEXT_MEDIUM,
  BOLD: FontFamilies.TEXT_BOLD
}, fontSizesSmall, lineHeights, true);
export default defaultTextStyles;
//# sourceMappingURL=index.js.map